import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';
import { ensureString } from 'utils/string';

export const getActScore = ({ studentId, version = 'v1' } = {}) => {
  let url = `${version}/test-scores/act/`;

  if (studentId) {
    url += `${studentId}/`;
  }
  return client
    .request({
      url,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);
};

export const getSatScore = ({ studentId, version = 'v1' } = {}) => {
  let url = `${version}/test-scores/sat/`;

  if (studentId) {
    url += `${studentId}/`;
  }
  return client
    .request({
      url,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);
};

export const getOtherScores = ({ params = {}, version = 'v1' } = {}) => {
  /* Optionally receive the student's id, which allows k12 admins or guardians to fetch
     the student's test data.
  */

  const url = `${version}/test-scores/student-scores/`;

  return client
    .request({
      url,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);
};

export const addScore = ({ data, testType, version = 'v1' }) =>
  client
    .request({
      url: `${version}/test-scores/${testType.toLowerCase()}/`,
      method: RequestMethod.POST,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteTestScore = ({
  testType,
  testUuid,
  studentId,
  version = 'v1',
}) =>
  client.request({
    url: `${version}/test-scores/${testType}/${testUuid}/${ensureString(
      studentId,
    )}`,
    method: RequestMethod.DELETE,
  });

export const getApScore = ({ studentId, version = 'v1' } = {}) => {
  let url = `${version}/test-scores/ap/`;
  if (studentId) {
    url += `${studentId}/`;
  }
  return client.request({
    url,
    method: RequestMethod.GET,
  });
};

export const getScoresContextData = ({ version = 'v1' } = {}) =>
  client.request({
    url: `${version}/test-scores/context/`,
    method: RequestMethod.GET,
  });

export const getClassRankData = ({ studentId, version = 'v1' } = {}) =>
  client.request({
    url: `${version}/test-scores/class-rank/`,
    method: RequestMethod.GET,
    params: studentId ? { student: studentId } : {},
  });
